export function isFormGroupField(name: string): boolean {
  return (name.match(/.*\[.*\]\..*/g) ?? []).length > 0;
}

export function splitFormGroupFieldName(name: string): {
  groupName: string;
  fieldIndex: string;
  fieldName: string;
} {
  const [groupName, fieldIndex, fieldName] = name
    .split(/\[|\]|\./g)
    .filter((s) => s.length);
  return { groupName, fieldIndex, fieldName };
}

